import {Slider} from '@wandb/weave/components';
import React, {FC, useState} from 'react';

import {useDebouncedValue} from '../../../../../util/useDebouncedValue';

type SettingsSliderInputProps = {
  initialValue: number;
  updateConfigCallback: (value: number) => void; // Should be a useCallback so that the debounce is not recreated on every render
  max: number;
  'data-test': string;
  'aria-labelledby': string;
};

export const SettingsSliderInput: FC<SettingsSliderInputProps> = ({
  initialValue,
  updateConfigCallback,
  max,
  'data-test': dataTest,
  'aria-labelledby': ariaLabelledBy,
}) => {
  const {value: debouncedValue, debouncedSetValue} = useDebouncedValue(
    initialValue,
    500,
    updateConfigCallback
  );

  // Local state to control the value of the slider so we don't have to wait for the updateConfig call to propagate
  const [value, setValue] = useState(debouncedValue);

  const onChange = (value: number | number[]) => {
    // Slider.Root only takes an array even though we only care about the first value
    const newValue = Array.isArray(value) ? value[0] : value;
    setValue(newValue);
    debouncedSetValue(newValue);
  };

  return (
    <div className="flex items-center">
      <div className="w-full">
        <Slider.Root
          aria-labelledby={ariaLabelledBy}
          min={1}
          max={max}
          step={1}
          value={[value]}
          onValueChange={onChange}>
          <Slider.Track>
            <Slider.Range className="bg-teal-400" />
          </Slider.Track>
          <Slider.Thumb />
        </Slider.Root>
      </div>
      <div>
        <Slider.Display
          className="w-[100px]"
          data-test={dataTest}
          aria-labelledby={ariaLabelledBy}
          min={1}
          max={max}
          step={1}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
